import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let _client = null;

function getClient() {
  if (!_client) {
    _client = new ApplicationInsights({
      config: {
        connectionString: process.env.REACT_APP_INSIGHTS_KEY,
        extensionConfig: {
          AppInsightsCfgSyncPlugin: {
            blkCdnCfg: true,
          },
        },
        // This singleton only emits AiToolUsage trackEvent calls — opt out of
        // everything the Web SDK auto-collects to avoid duplicate telemetry with
        // the existing per-component ApplicationInsights instances.
        disableAjaxTracking: true,
        disableFetchTracking: true,
        disableExceptionTracking: true,
        enableAutoRouteTracking: false,
      },
    });
    _client.loadAppInsights();
  }
  return _client;
}

/** Returns the client name with the +guid suffix stripped. */
export function getClientName() {
  return (localStorage.getItem("client") || "").split("+")[0] || "unknown";
}

/**
 * Track an AI tool interaction event from the browser.
 * Safe no-op when REACT_APP_INSIGHTS_KEY is not set.
 *
 * Note: client events intentionally omit `provider` — panel-open,
 * recommendation-click, etc. have no associated LLM provider.
 *
 * @param {string} feature  - "report_copilot" | "snowflake_analyst" | "snowflake_agent" | "ppt_slide_summaries"
 * @param {string} action   - "panel_opened" | "recommendation_clicked" | "ai_summary_enabled" | ...
 * @param {object} [extra]  - any additional string dimensions
 */
export function trackAiEvent(feature, action, extra = {}) {
  if (!process.env.REACT_APP_INSIGHTS_KEY) return;
  try {
    getClient().trackEvent({
      name: "AiToolUsage",
      properties: {
        feature,
        action,
        client: getClientName(),
        user: localStorage.getItem("user") || "unknown",
        source: "client_app",
        ...extra,
      },
    });
  } catch (_) {
    // telemetry must never break the UI
  }
}

export function trackClientEvent(name, properties = {}, measurements = {}) {
  if (!process.env.REACT_APP_INSIGHTS_KEY) return;
  try {
    getClient().trackEvent({
      name,
      properties: {
        client: getClientName(),
        user: localStorage.getItem("user") || "unknown",
        source: "client_app",
        ...properties,
      },
      measurements,
    });
  } catch (_) {
    // telemetry must never break the UI
  }
}
